import { MINIAPP_SHARE_URL, PROFILE_URL } from "@/constants/url";
import style from "./style.module.scss";

const Intro = () => {
  return (
    <div className={style.wrapper}>
      <div className={style.socialsButtonWrapper}>
        <a
          className={style.socialsButton}
          href={PROFILE_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className={style.socialsButtonImg}>
            <img src="/images/farcaster-purple.svg" alt="" />
          </div>
          <p>Farcaster</p>
        </a>
        <a
          className={style.socialsButton}
          href={MINIAPP_SHARE_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className={style.socialsButtonImg}>
            <img src="/images/farcaster-white.svg" alt="" />
          </div>
          <p>Mini App</p>
        </a>
      </div>

      <video
        className={style.video}
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
      >
        <source src="/video/video.mp4" type="video/mp4" />
      </video>
    </div>
  );
};

export default Intro;
